// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3_rua container-1avof"};